import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBarRef
} from '@angular/material/snack-bar';
import { IAlertData } from './alert-data.interface';

@Component({
    selector: 'p-snackbar',
    template: ` <p-alert [data]="alertData" [centralize]="true" (closeClick)="close()"></p-alert> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PSnackbarComponent {
    public alertData;

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: IAlertData, public ref: MatSnackBarRef<PSnackbarComponent>) {
        this.alertData = data;
    }

    close() {
        this.ref.dismiss();
    }
}
